module.exports = __webpack_public_path__ + "static/media/0008.03ef633c.png";